import {
    createCatalogContent,
    deleteCatalogContent,
    getCatalogContent,
    updateCatalogContent,
    getCatalogContentByParent,
} from "../../api/catalogContent.js";
import { toArray, toObject } from "../../utils/languageContent";
import { getCatalogCategoryById } from "../../api/catalogCategory";

const catalogContent = {
    namespaced: true,
    state: {
        catalogContents: [],
    },
    getters: {
        getMappedCatalogContent: (state) => {
            let result = state.catalogContents.map(toObject);
            return result;
        },
        getCatalogContentParent: (state, id) => {
            return state.catalogContents.map(toObject).filter((p) => p.parent === id);
        },
    },
    mutations: {
        SET_CATALOG_CONTENTS: (state, payload) => {
            state.catalogContents = payload;
        },
        ADD_CATALOG_CONTENT: (state, payload) => {
            state.catalogContents.push(payload);
            state.catalogContents.total++;
        },
        UPDATE_CATALOG_CONTENT: (state, payload) => {
            let catalogContent = state.catalogContents.find((p) => p._id === payload._id);
            catalogContent = payload;
        },
        DELETE_CATALOG_CONTENT: (state, id) => {
            state.catalogContents = state.catalogContents.filter((r) => r._id !== id);
            state.catalogContents.total--;
        },
    },
    actions: {
        getCatalogContents({ commit }) {
            return getCatalogContent().then((response) => {
                commit("SET_CATALOG_CONTENTS", response.data);
            });
        },
        getCatalogContent({ state }, id) {
            return state.catalogContents.map(toObject).find((p) => p._id === id);
        },
        getCatalogContentByParent({ state }, id) {
            return getCatalogContentByParent(id).then((response) => {
                let data = null;
                if (response.data) data = toObject(response.data);
                return Promise.resolve(data);
            });
        },
        createCatalogContent({ commit }, payload) {
            return createCatalogContent(toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("ADD_CATALOG_CONTENT", data);
                return Promise.resolve(data);
            });
        },
        updateCatalogContent({ commit }, payload) {
            return updateCatalogContent(payload._id, toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("UPDATE_CATALOG_CONTENT", data);
                return Promise.resolve(data);
            });
        },
        deleteCatalogContent({ commit }, id) {
            return deleteCatalogContent(id).then((response) => {
                commit("DELETE_CATALOG_CONTENT", id);
                return Promise.resolve(response);
            });
        },
    },
};

export default catalogContent;
